/**
 * @generated SignedSource<<023e4dcaa17d686184e0df3dbfe0c71b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Duration_build$data = {
  readonly clockDurationInSeconds: number | null;
  readonly " $fragmentType": "Duration_build";
};
export type Duration_build$key = {
  readonly " $data"?: Duration_build$data;
  readonly " $fragmentSpreads": FragmentRefs<"Duration_build">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Duration_build",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clockDurationInSeconds",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "0fa7eb541ea5082f8b695a5ef68240ab";

export default node;
